(function () {
  "use strict";

  const VAT_RATE_DEFAULT = 0.21;
  const STORAGE_KEY = "vatMode";

  function init() {
    let mode = "incl";
    let updateScheduled = false;

    try {
      const savedMode = localStorage.getItem(STORAGE_KEY);

      if (savedMode === "incl" || savedMode === "excl") {
        mode = savedMode;
      }
    } catch (e) {
      // De schakelaar blijft werken als browseropslag geblokkeerd is.
    }

    const currencyFormatter = new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    // Alleen schrijven als de tekst verandert.
    // Dit voorkomt een lus met de MutationObserver.
    function setText(element, text) {
      if (element && element.textContent !== text) {
        element.textContent = text;
      }
    }

    function applyVatMode() {
      const isIncl = mode === "incl";

      document.querySelectorAll("#toggleVAT").forEach(function (toggle) {
        toggle.checked = !isIncl;
      });

      document.querySelectorAll(".vat-toggle__label-text").forEach(function (label) {
        setText(
          label,
          isIncl ? "Prijzen incl. btw" : "Prijzen excl. btw"
        );
      });

      document.querySelectorAll(".vat-price").forEach(function (element) {
        const rawBase = element.getAttribute("data-base-price");

        if (rawBase === null || rawBase.trim() === "") return;

        const base = Number(rawBase);
        if (!Number.isFinite(base)) return;

        const rawRate = element.getAttribute("data-vat-rate");
        const parsedRate =
          rawRate !== null && rawRate.trim() !== ""
            ? Number(rawRate)
            : VAT_RATE_DEFAULT;

        const vatRate = Number.isFinite(parsedRate)
          ? parsedRate
          : VAT_RATE_DEFAULT;

        const amount = isIncl ? base * (1 + vatRate) : base;

        setText(
          element.querySelector(".vat-price__amount"),
          currencyFormatter.format(amount)
        );

        setText(
          element.querySelector(".vat-price__label"),
          isIncl ? "incl. btw" : "excl. btw"
        );
      });
    }

    // Meerdere wijzigingen samen in één update verwerken.
    function scheduleUpdate() {
      if (updateScheduled) return;

      updateScheduled = true;

      requestAnimationFrame(function () {
        updateScheduled = false;
        applyVatMode();
      });
    }

    // Blijft ook werken als de toggle opnieuw wordt ingeladen.
    document.addEventListener("change", function (event) {
      if (!event.target || event.target.id !== "toggleVAT") return;

      mode = event.target.checked ? "excl" : "incl";

      try {
        localStorage.setItem(STORAGE_KEY, mode);
      } catch (e) {
        // Browseropslag is optioneel.
      }

      applyVatMode();
    });

    applyVatMode();

    // Gerelateerde producten, variantprijzen en andere
    // dynamisch ingeladen prijsblokken automatisch bijwerken.
    const observer = new MutationObserver(function (mutations) {
      const relevantChange = mutations.some(function (mutation) {
        if (mutation.type === "attributes") return true;

        const target =
          mutation.target.nodeType === Node.ELEMENT_NODE
            ? mutation.target
            : mutation.target.parentElement;

        if (
          target &&
          target.closest(".vat-price, .vat-toggle")
        ) {
          return true;
        }

        return Array.from(mutation.addedNodes).some(function (node) {
          return (
            node.nodeType === Node.ELEMENT_NODE &&
            (
              node.matches(".vat-price, .vat-toggle") ||
              node.querySelector(".vat-price, .vat-toggle")
            )
          );
        });
      });

      if (relevantChange) scheduleUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["data-base-price", "data-vat-rate"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();